module.exports = __webpack_public_path__ + "img/yes.6928c95d.svg";